import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top every time the route pathname changes.
 * Mounted once inside <Router>, renders nothing.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Plain scrollTo (not smooth) so the user lands at the top instantly,
    // not mid-scroll animating from wherever the previous page left off.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
